import StorageUtil from "./storage-util";
import {SystemConst} from "./constant";

const origin = (typeof window.location.origin === 'undefined' ?
    (window.location.protocol + "//" + window.location.host) : window.location.origin);
const prodHost = 'holaplaza';
const testHost = '51smzx';
const devHost = `http://${location.hostname}`;
const UrlUtil = {
    getAPI() {
        if (process.env.API_ENV === 'prod') {
            return `https://api.holapago.com`;
        } else if (process.env.API_ENV === 'test') {
            // return `http://api.${testHost}.cn`;
            return `http://api.yimaideng.cn`;
        } else {
            return `${devHost}:8990`;
            // return `http://ystest01.yunshl.com`;
            // return `http://192.168.0.208:8990`;
            //return `http://api.yimaideng.cn`;
            // return `https://api.holapago.com`;

        }
    },
    getMShopUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://m.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://m.${testHost}.cn`
        } else {
            return `${devHost}:8991`;
        }
    },
    getMMgrUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://mgr.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://mgr.${testHost}.cn`
        } else {
            return `${devHost}:8996`;
        }
    },
    getLightUrl: () => {
        if (process.env.API_ENV === 'prod') {
            return `https://pd.${prodHost}.com`
        } else if (process.env.API_ENV === 'test') {
            return `http://pd.${testHost}.cn`
        } else {
            return `${devHost}:9002`;
        }
    },
    getAccountUrl: (companyID) => {
        const companyData = StorageUtil.getItem(SystemConst.companyData);
        if (process.env.API_ENV === 'prod') {
            // return companyID ? `https://store${companyID}.${prodHost}.com` : `https://account.${prodHost}.com`
            return companyData.pc_domain_
        } else if (process.env.API_ENV === 'test') {
            return companyID ? `http://store${companyID}.${testHost}.cn` : `http://account.${testHost}.cn`
        } else if (window.location.href.indexOf('192.168')) {
            return `${devHost}:8993`;
        }
    }
};
export default UrlUtil;



// WEBPACK FOOTER //
// ./src/utils/url-config.js